<script>
  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Banner from "../component/Banner.svelte";
  import Footer from "../component/Footer.svelte";
  import Details from "../component/Details.svelte";
  import Information from "../component/Information.svelte";
  import SiteMap from "../component/SiteMap.svelte";
  import Copyright from "../component/Copyright.svelte";
  import { Button, Label, Logo } from "../component/widget";
  import { navigate } from "../router";

  function goToPricing() {
    /*
    navigate("#/pricing");
    */
  }
</script>

<main>
  <CookieConsent />
  <Header>
    <Button action={goToPricing}>
      <Label text="Nos offres" border h="48px" />
    </Button>
  </Header>
  <Banner />
  <Footer />
  <Details />
  <Information />
  <SiteMap />
  <Copyright company="KiwisApp" />
</main>

<style>
  main {
    position: relative;
    overflow: hidden;
    font-size: 1rem;
    font: inherit;
    text-align: center;
    border: 0;
    padding: 0;
    flex: 1 1 0px;
    display: flex;
    flex-direction: column;
    font-family: Poppins, sans-serif;
  }
</style>
